import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../../data/site";

const NAV_LINKS = [
    { label: "Home", href: "/" },
    { label: "Services", href: "/#services" },
    { label: "Areas", href: "/#areas" },
    { label: "Seniors", href: "/#seniors" },
    { label: "Business", href: "/#business" },
    { label: "About", href: "/#about" },
    { label: "Pricing", href: "/pricing" },
    { label: "Contact", href: "/#contact" },
];

export const Header = () => (
    <header data-testid="site-header" className="sticky top-0 z-50 bg-white border-b border-slate-100 shadow-sm">
        <div className="bg-[#0F2E52] text-white text-xs">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 py-1.5 flex items-center justify-between gap-2">
                <a
                    href={PHONE_TEL}
                    data-testid="topbar-phone-link"
                    className="inline-flex items-center gap-1.5 font-medium hover:underline"
                >
                    <Phone className="w-3 h-3" /> {PHONE_DISPLAY} · Call to book a callout
                </a>
                <span className="hidden sm:inline text-blue-200">
                    We come to your home or business · No call centres
                </span>
            </div>
        </div>
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
            <div className="flex items-center justify-between gap-3 py-2.5 lg:py-3">
                <Link to="/" data-testid="header-logo-link" className="min-w-0 leading-tight shrink flex items-center gap-2.5">
                    <img src="/logo-icon.png" alt="" className="w-9 h-9 sm:w-10 sm:h-10 object-contain shrink-0" />
                    <span>
                        <span className="block font-heading font-bold text-[#0F2E52] text-base sm:text-lg">
                            Computer Repairs Semaphore
                        </span>
                        <span className="block text-xs sm:text-sm font-medium text-slate-600">Operated by Tech Emergency</span>
                    </span>
                </Link>
                <nav className="hidden lg:flex items-center gap-5" aria-label="Main navigation">
                    {NAV_LINKS.map((link) => (
                        <a
                            key={link.href}
                            href={link.href}
                            data-testid={`nav-${link.label.toLowerCase()}-link`}
                            className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors"
                        >
                            {link.label}
                        </a>
                    ))}
                </nav>
                <a
                    href={PHONE_TEL}
                    data-testid="header-call-now-button"
                    className="shrink-0 inline-flex items-center gap-1.5 bg-[#0F2E52] hover:bg-blue-900 text-white text-sm font-semibold rounded-full px-4 py-2 transition-colors"
                >
                    <Phone className="w-4 h-4" />
                    <span className="hidden sm:inline">{PHONE_DISPLAY}</span>
                    <span className="sm:hidden">Call</span>
                </a>
            </div>
        </div>
    </header>
);
